<template>
  <div class="base-outreach-contact-stat">
    <slot />

    <BaseStreemTooltip v-if="props.tooltip">
      {{ props.tooltip }}
    </BaseStreemTooltip>
  </div>
</template>

<script setup lang="ts">
import { BaseStreemTooltip } from "shared/components/base";

interface BaseOutreachContactStat {
  tooltip?: string;
}

const props = defineProps<BaseOutreachContactStat>();
</script>

<style lang="scss" scoped>
.base-outreach-contact-stat {
  padding-inline: var(--s-spacing-md);
  padding-block: var(--s-spacing-xs);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  gap: var(--s-spacing-md);
  color: var(--s-color-blue-9);
  font-weight: 500;

  &:hover {
    color: var(--s-title-hover);
  }
}
</style>
